import { render, staticRenderFns } from "./TabBase.vue?vue&type=template&id=6cb6b50a&"
import script from "./TabBase.vue?vue&type=script&lang=js&"
export * from "./TabBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports